<div class="video-modal">
  <div class="video-container">
    <iframe
      [src]="data.videoUrl | youtubeEmbedUrl"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
      [title]="data.title"></iframe>
  </div>
</div>
